import { useStore } from "@/stores/useStore";
import { Button } from "@/components/base/Button.tsx";
import { PageHeading } from "@/components/common/PageHeading.tsx";

const VerifyPage = () => {
  const sendVerificationEmail = useStore((s) => s.sendVerificationEmail);
  const handleVerify = () => {
    sendVerificationEmail();
  };

  return (
    <div className="flex flex-col gap-4 m-auto">
      <PageHeading>Verify Your E-mail</PageHeading>
      <div className="max-w-screen-md">
        You must verify ownership of the email address used during account
        creation. Please click the button below and follow the steps in the
        email.
      </div>
      <Button onClick={handleVerify}>Verify Email</Button>
    </div>
  );
};

export default VerifyPage;
